import { useAuth } from "react-oidc-context";

import type { UseLogoutUserReturnType } from "@/hooks/auth/logoutUser/types";

export const useLogoutUser = (): UseLogoutUserReturnType => {
  const { signoutRedirect, removeUser } = useAuth();
  const logoutUser = () => {
    removeUser();
    signoutRedirect();
  };

  return { logoutUser };
};
